
/*========================================================================
* $Id: browser.js 151646 2018-04-26 12:10:53Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

Mindbreeze.define('utils/browser',["underscore"], function(_) {

    var urlParameters,
    _initURLParameters = function () {
      urlParameters = {};

      try {
        var parameters = location.search.substring(1).replace(/\+/g, ' ').split('&');

        _.each(parameters, function (parameter) {
            var name, value,
                splitParameter = parameter.split('=');

            name = splitParameter[0];
            if (splitParameter.length > 1) {
              try {
                value = decodeURIComponent(splitParameter[1]);
                urlParameters[name] = value;
              } catch (e) {}
            }

        });
      } catch (e) { }
    };

    function getURLParameterByString (name, url) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function getURLParametersByString (url) {
      var urlParameters = {};
      var parameters = url.split("?")[1] && url.split("?")[1].replace(/\+/g, ' ').split('&');

      _.each(parameters, function (parameter) {
        var name, value,
        splitParameter = parameter.split('=');

        name = splitParameter[0];
        if (splitParameter.length > 1) {
          try {
            value = decodeURIComponent(splitParameter[1]);
            urlParameters[name] = value;
          } catch (e) {}
        }

      });

      return urlParameters; 
    }

    function getBrowserName() {
      // Opera 8.0+
      var opr = opr;
      var isOpera = (!!window.opr && opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';
      // Safari 3.0+ "[object HTMLElementConstructor]" 
      var safari = safari || false;
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (safari && safari.pushNotification));
      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;
      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;
      // Chrome 1+
      var isChrome = !!window.chrome && !!window.chrome.webstore;
      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;

      if (isOpera) return "Opera";
      else if (isFirefox) return "Firefox";
      else if (isSafari) return "Safari";
      else if (isIE) return "IE";
      else if (isEdge) return "Edge";
      else if (isChrome) return "Chrome";
      else if (isBlink) return "Blink";
      else return null;
    }

    var browser = {
      getURLParameter: function (name, force) {
        return this.getURLParameters(force)[name];
      },

      getURLParameters: function(force) {
        if (force || typeof urlParameters === 'undefined') {
          _initURLParameters();
        }
        return urlParameters; 
      },

      getURLParameterByString: function (parameter, strURL) {
        return getURLParameterByString(parameter, strURL);
      },

      getURLParametersByString: function (strURL) {
        return getURLParametersByString(strURL);
      },

      getURL: function () {
        var window = this.getWindow();
        return window && window.location.href;
      },

      getScheme: function () {
        var window = this.getWindow();
        return window && window.location.protocol;
      },

      getHostname: function () {
        var window = this.getWindow();
        return window && window.location.host;
      },

      getPort: function () {
        var window = this.getWindow();
        return window && window.location.port;
      },

      getPathname: function () {
        var window = this.getWindow();
        return window && window.location.pathname;
      },

      getHashValue: function () {
        var window = this.getWindow();
        return window && window.location.hash;
      },

      getWindow: function () {
        if (typeof window === "undefined") return;
        return window;
      },

      hasIEVendorPrefix: function () {
        return ("msTransition" in document.createElement("div").style);
      },

      isTouchDevice: function () {
        var el = document.createElement('div');
        el.setAttribute('ontouchstart', 'return;');

        if (typeof el.ontouchstart == "function"){
          return true;
        } else {
          return false
        }
      },

      isMobileSafari: function () {
        return / Mobile\//.test(navigator.userAgent) && / Safari\//.test(navigator.userAgent);
      },

      localStorageAvailable: function () {
        var key = "localStorageAvailable" + new Date().getTime();
        try {
          localStorage[key] = "true";
          localStorage.removeItem(key);
          return true;
        } catch (e) {
          return false;
        }
      },

      loadCSS: function (url, id) {
         var el = document.getElementById(id);
         if (!el) {
           el = document.createElement("link");
           el.rel = "stylesheet";
           el.href = url;
           el.id = id;
           (document.head || document.getElementsByTagName("script")[0].parentNode).appendChild(el);
         }
      },

      getBrowserName: function () {
        return getBrowserName();
      }

    };

    browser.isMobileSafariPrivateMode = function () {
        return browser.isMobileSafari() && !browser.localStorageAvailable();
    };

    return browser;

});
